import { font } from './Font'
import { PDFHeader } from './PDFHeader'

export const PDFTable = async ({
  pdf,
  currentY,
  headers,
  data,
  statusColors,
  columnStyles,
  type,
  headerImage,
  instituteDetails,
  chartElement,
  year,
}) => {
  const estimatedTableHeight = data.length * 10 + 20 // Approximate row height * number of rows + header height
  const pageHeight = pdf.internal.pageSize.height

  // Check if the table fits or needs a new page
  if (currentY + estimatedTableHeight > pageHeight - 20) {
    pdf.addPage() // Add a new page before drawing the table

    await PDFHeader({
      pdf,
      headerImage,
      instituteDetails,
      chartElement,
      year,
    })

    currentY = 50 // Reset Y position for the new page
  }

  pdf.autoTable({
    startY: currentY, // Start position (Ensure it’s not dependent on canvas)
    columns: headers, // Use columns instead of head
    body: data,
    theme: 'grid',
    styles: { fontSize: 12, textColor: [40, 40, 40] },
    headStyles: {
      fillColor: [238, 238, 238],
      textColor: 0,
      fontStyle: 'bold',
      halign: 'center',
    },
    // alternateRowStyles: { fillColor: [240, 240, 240] },
    columnStyles: columnStyles,
    // Add colored legend in Status column
    didDrawCell: data => {
      if (
        data.column.dataKey === 'value' &&
        data.section === 'body' &&
        type === 'ctcCategory'
      ) {
        let status = data.cell.raw

        if (type === 'ctcCategory') {
          pdf.setFont('Roboto', 'normal')
          pdf.addFileToVFS('Roboto-Thin-normal.ttf', font())
          pdf.addFont('Roboto-Thin-normal.ttf', 'Roboto', 'normal')
          pdf.setFont('Roboto')
        }
        // status = status.replace(/₹|¹/g, 'INR ')
        const circleX = data.cell.x + 5 // Shift left for circle
        const circleY = data.cell.y + data.cell.height / 2 // Center vertically
        pdf.setTextColor(0, 0, 0)
        // Increase column width if necessary
        data.cell.width = Math.max(
          data.cell.width,
          pdf.getTextWidth(status) + 20
        )

        pdf.setFontSize(10)

        // Ensure text fits properly
        const textLines = pdf.splitTextToSize(status, data.cell.width - 10)
        pdf.text(textLines, circleX + 8, circleY + 2)
      }

      if (data.column.dataKey === 'label' && data.section === 'body') {
        let status = data.cell.raw
        // status = status.replace(/₹|¹/g, 'INR ')
        if (type === 'ctcAnalysis') {
          pdf.setFont('Roboto', 'normal')
          pdf.addFileToVFS('Roboto-Thin-normal.ttf', font())
          pdf.addFont('Roboto-Thin-normal.ttf', 'Roboto', 'normal')
          pdf.setFont('Roboto')
        }
        const color = data?.row?.raw?.rgb ??
          statusColors[status?.toLowerCase()] ??
          data?.row?.raw?.backgroundColor ?? [0, 0, 0] // Default to black

        const circleX = data.cell.x + 5 // Shift left for circle
        const circleY = data.cell.y + data.cell.height / 2 // Center vertically
        const radius = 2 // 5px diameter (2.5px radius)

        pdf.setFillColor(...color)
        pdf.circle(circleX, circleY, radius, 'F') // Draw filled circle
        pdf.setTextColor(40, 40, 40)

        // Increase column width if necessary
        data.cell.width = Math.max(
          data.cell.width,
          pdf.getTextWidth(status) + 20
        )

        pdf.setFontSize(10)

        // Ensure text fits properly
        const textLines = pdf.splitTextToSize(status, data.cell.width - 10)
        pdf.text(textLines, circleX + 8, circleY + 2)
      }

      if (
        data?.column.dataKey === 'absoluteNumbers' &&
        data.section === 'body'
      ) {
        const cellText = data.cell.raw || '' // Ensure there's text

        // Extract total count and category details
        const match = cellText.match(/^(\d+)\s*\((.*?)\)$/)
        const totalStudents = match ? match[1] : cellText
        const categories = match ? match[2] : ''

        const x = data.cell.x + 2
        const y = data.cell.y + data.cell.height / 2 + 2

        pdf.setTextColor(0, 0, 0) // Black for total count
        pdf.text(totalStudents, x, y)

        let currentX = x + pdf.getTextWidth(totalStudents)

        if (categories) {
          // Split categories and remove entries that start with "0"
          const filteredCategories = categories
            .split(' / ')
            .filter(category => !category.startsWith('0'))

          // If all categories were "0", do not display anything
          if (filteredCategories.length === 0) return

          pdf.setTextColor(0, 0, 0) // Black for opening bracket
          pdf.text(' (', currentX, y)
          currentX += pdf.getTextWidth(' (')

          filteredCategories.forEach((category, index, arr) => {
            if (category.includes('M'))
              pdf.setTextColor('#2BB7DC') // Blue for M
            else if (category.includes('F'))
              pdf.setTextColor('#DC2B8F') // Red for F
            else if (category.includes('Others')) pdf.setTextColor('#8E8E8E') // Gray for Others

            pdf.text(category, currentX, y)
            currentX += pdf.getTextWidth(category)

            // Add separator with black color
            if (index < arr.length - 1) {
              pdf.setTextColor(0, 0, 0)
              pdf.text(' / ', currentX, y)
              currentX += pdf.getTextWidth(' / ')
            }
          })

          pdf.setTextColor(0, 0, 0) // Black for closing bracket
          pdf.text(')', currentX, y)
        }
      }
    },
  })

  // Return the updated Y position after the table
  return pdf.autoTable.previous.finalY || currentY
}
